import { ScrollArea } from '@/components/ui/scroll-area'
import { RawDataDialogProps } from '../../utils/contentTypes'
import { ClipboardCopy } from '../../previews/ClipboardCopy'
import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
} from "@/components/ui/dialog"

/**
 * Dialog for showing raw content data (for superadmin debugging)
 */
export function RawDataDialog({
    content,
    isOpen,
    onClose
}: RawDataDialogProps) {
    return (
        <Dialog open={isOpen} onOpenChange={onClose}>
            <DialogContent className="max-w-4xl max-h-[80vh]">
                <DialogHeader>
                    <DialogTitle>Raw Content Data</DialogTitle>
                </DialogHeader>
                <ScrollArea className="mt-4 h-[60vh]">
                    <pre className="p-4 bg-secondary/50 rounded-md overflow-x-auto">
                        {JSON.stringify(content, null, 2)}
                    </pre>
                </ScrollArea>
                <div className="flex justify-end mt-4">
                    <ClipboardCopy
                        text={JSON.stringify(content, null, 2)}
                        variant="button"
                        labelText="Copy Raw Data"
                    />
                </div>
            </DialogContent>
        </Dialog>
    )
}